import get from 'lodash/get';
import { PapiDeviation } from '@wix/da-papi-types';
import { DeviationTypes } from '../types/deviation';
import { usePrimaryTier } from '../Tier/PrimaryTierContext';
import { isSimpleDeviation, getDeviationType } from '../DeviationViews/_helpers';

export default function useDeviationStats(deviation: PapiDeviation) {
  const isComplexType = !isSimpleDeviation(deviation);
  const primaryTier = usePrimaryTier(deviation);

  return {
    faves: get(deviation, 'stats.favourites', 0) as number,
    isFavouritable: isComplexType,

    comments: get(deviation, 'stats.comments', 0) as number,
    isCommentable: deviation.isCommentable,

    views: get(deviation, 'stats.views', 0) as number,
    viewsToday: get(deviation, 'extended.stats.today', 0) as number,
    isViewCountable: isComplexType,

    groups: get(deviation, 'extended.stats.groups', 0) as number,

    subscribers: get(primaryTier || deviation, 'tier.stats.subscribers'),
    isSubscribable: getDeviationType(deviation) === DeviationTypes.TIER,
    isInSubscription: !!primaryTier,

    premiumDownloads: get(deviation, 'pcp.salesCount', 0) as number,

    privatelyCollected: get(deviation, 'stats.privatelyCollected', 0) as number,

    hasTooltips: isComplexType,
  };
}
